import { render, staticRenderFns } from "./DetailSection.vue?vue&type=template&id=da04d8ec"
import script from "./DetailSection.vue?vue&type=script&lang=js"
export * from "./DetailSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports